import { createSelector } from 'reselect';
import { getSelectionRangeDetail } from '../../abstractselection/getSelectionRangeDetail';
import { getAnchorFromDocument } from '../../anchor/getAnchorFromDocument';

import { selector } from './reducer';

const parseSelection = (text: string) => {
  if (!text) {
    return null;
  }
  const [start, end] = text.split('|').qSelect((x) => x.trim());

  return { start, end };
};

export default {
  creating: createSelector(selector, (state) => state.creating),
  selection: createSelector(selector, (state) => parseSelection(state.selection)),
  text: createSelector(selector, (state) => {
    if (state.selection) {
      var root = getAnchorFromDocument();
      var start = parseSelection(state.selection).start;
      var end = parseSelection(state.selection).end;
      var textInfo = getSelectionRangeDetail(root, start, end);
      return textInfo&&textInfo.textStart&&textInfo.textStart.textContent?textInfo.textStart.textContent:'';
    }
    return '';
  }), 
  isnote: createSelector(selector, (state) => state.isnote),
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/selection/selectors.tsx